import { InjectionToken } from '@angular/core';

export interface MessageConfig {
  position?: 'center' | 'right';
}

export const MESSAGE_CONFIG = new InjectionToken<MessageConfig>(
  'MESSAGE_CONFIG'
);

export const MESSAGE_DEFAULT_CONFIG = new InjectionToken<MessageConfig>(
  'MESSAGE_DEFAULT_CONFIG'
);

export const MESSAGE_DEFAULT_CONFIG_PROVIDER = {
  provide: MESSAGE_DEFAULT_CONFIG,
  useValue: {
    position: 'right'
  }
};
